import RsTableHeaderLabel from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderLabel';
import React from 'react';
import PropTypes from 'prop-types';

import './PlanPublishedTableHeader.scss';

function PlanPublishedTableHeader({ isInHouse }) {
  return (
    <tr className="c-els-table__row c-els-table__row--head c-els-table__row--sticky">
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        <RsTableHeaderLabel />
      </th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">Optional single step to be added</th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">Conditions</th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header rx-reactions-table__yield">Yield</th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header u-els-display-none@tablet">
        {isInHouse ? 'Reference/Experiment' : 'Reference'}
      </th>
    </tr>
  );
}

PlanPublishedTableHeader.defaultProps = {
  isInHouse: false,
};

PlanPublishedTableHeader.propTypes = {
  isInHouse: PropTypes.bool,
};

export default PlanPublishedTableHeader;
